import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { isMobile } from "./helpers";
import { useLocation } from "react-router-dom";

function Navbar() {
  const [weather, setWeather] = useState(null);
  const [time, setTime] = useState(new Date());
  const [error, setError] = useState(null);
  const location = useLocation();

  useEffect(() => {
    let isMounted = true;

    // Update time every second
    const timeInterval = setInterval(() => {
      if (isMounted) {
        setTime(new Date());
      }
    }, 1000);

    // Fetch weather data
    const fetchWeather = async () => {
      try {
        // First, get the grid coordinates for Brooklyn, NY
        const pointsResponse = await fetch(
          "https://api.weather.gov/points/40.642821,-73.943811" // Brooklyn, NY coordinates
        );
        const pointsData = await pointsResponse.json();

        if (!pointsData.properties?.observationStations) {
          throw new Error("Could not get observation stations URL");
        }

        // Get the nearest observation station
        const stationsResponse = await fetch(
          pointsData.properties.observationStations
        );
        const stationsData = await stationsResponse.json();

        if (!stationsData.features?.[0]?.properties?.stationIdentifier) {
          throw new Error("No observation stations found");
        }

        // Get the current observation from the nearest station
        const stationId = stationsData.features[0].properties.stationIdentifier;
        const observationResponse = await fetch(
          `https://api.weather.gov/stations/${stationId}/observations/latest`
        );
        const observationData = await observationResponse.json();

        if (isMounted) {
          if (observationData.properties) {
            setWeather({
              temperature: Math.round(
                (observationData.properties.temperature.value * 9) / 5 + 32
              ), // Convert C to F
              shortForecast: observationData.properties.textDescription,
            });
            setError(null);
          } else {
            setError("Weather data unavailable");
          }
        }
      } catch (error) {
        if (isMounted) {
          console.error("Error fetching weather:", error);
          setError("Failed to fetch weather");
        }
      }
    };

    fetchWeather();
    const weatherInterval = setInterval(fetchWeather, 300000); // Update every 5 minutes

    return () => {
      isMounted = false;
      clearInterval(timeInterval);
      clearInterval(weatherInterval);
    };
  }, []);

  const formatTime = (date) => {
    return date.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
      timeZone: "America/New_York",
    });
  };

  // Check if on MoreWork page
  const isMoreWork = location.pathname.includes("morework");

  return (
    <NavbarWrapper>
      <NavbarGroup>
        {isMoreWork ? (
          <LinkWrapper href={"/"}>
            <PageHeaderTitle>Aaron Edwards</PageHeaderTitle>
          </LinkWrapper>
        ) : (
          <NavbarItem>
            <i>Brooklyn, NY</i> | {formatTime(time)}
            {error
              ? ""
              : weather
              ? ` | ${weather.temperature}°F${
                  !isMobile() ? ` ${weather.shortForecast}` : ""
                }`
              : ""}
          </NavbarItem>
        )}
      </NavbarGroup>
      <NavbarGroup>
        <NavbarItem>
          <NavLink href="/morework" $active={isMoreWork}>
            More Work
          </NavLink>
        </NavbarItem>
        <NavbarItem>
          <NavLink
            href="https://www.youtube.com/watch?v=3k_EBbZdUO0"
            target="_blank"
          >
            On My Mind
          </NavLink>
        </NavbarItem>
      </NavbarGroup>
    </NavbarWrapper>
  );
}

export default Navbar;

const NavbarWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

const NavbarGroup = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 25px;

  @media only screen and (max-width: 600px) {
    gap: 15px;
  }
`;

const NavbarItem = styled.div`
  font-size: 16px;
  font-weight: 400;
  font-family: forma-djr-deck, sans-serif;
  color: #000000;
  text-decoration: none;
  letter-spacing: 0.015em;

  @media only screen and (max-width: 600px) {
    font-size: 14px;
  }
`;

const NavLink = styled.a`
  color: inherit;
  text-decoration: none;
  font-style: ${({ $active }) => ($active ? "italic" : "normal")};
  transition: text-decoration 0.2s ease;
  &:hover {
    text-decoration: underline;
  }
`;

const LinkWrapper = styled.a`
  color: inherit;
  text-decoration: none;
  cursor: pointer;
`;

const PageHeaderTitle = styled.p`
  font-size: 30px;
  line-height: 20px;
  font-weight: 300;

  @media only screen and (max-width: 600px) {
    font-size: 22px;
  }
`;
